export const containerStyles = `flex flex-col justify-center items-center text-center w-full mb-[32px]`

export const descriptionStyles = `break-words max-w-sm text-md-regular`

export const titleStyles = `text-xl-semibold mb-[8px] `

export const imgClass = `mb-24px`
